// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-LogOutButton-style__button__ac7nZ{text-transform:uppercase;font-weight:700;border-radius:15px;font-size:.9em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `components-LogOutButton-style__button__ac7nZ`
};
export default ___CSS_LOADER_EXPORT___;
